<template>
  <div class="w-screen h-screen flex">
    <!-- Left Section (Logo) -->
    <div
      class="left-section w-1/2 flex flex-col items-center justify-center p-10"
    >
      <figure class="logo-container mb-8">
        <img src="@/assets/main-logo.png" alt="Logo" class="h-20" />
      </figure>
    </div>

    <!-- Right Section (Form) -->
    <div class="w-1/2 bg-white flex items-center justify-center">
      <div
        class="bg-white shadow-lg rounded-xl p-8 max-w-md w-full border border-gray-200"
      >
        <!-- Title -->
        <div class="text-xl font-semibold text-gray-800 mb-6 text-center">
          Reset Your Password
        </div>

        <!-- Email Input -->
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-medium mb-2"
            >Email</label
          >
          <input
            class="custom-input custom-focus"
            type="email"
            v-model="email"
            placeholder="Enter your email"
            @keyup.enter="submit"
          />
        </div>

        <!-- Error Message -->
        <div
          v-if="error"
          class="error-message flex items-center justify-between p-3 mb-4"
        >
          <div class="flex items-center">
            <i class="fas fa-exclamation-circle text-red-600 mr-2 mt-0.5"></i>
            <span class="text-red-600 font-medium">{{ error }}</span>
          </div>
          <button @click="error = ''" class="text-red-600 hover:text-red-800">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Success Message -->
        <div
          v-if="success"
          class="text-green-600 text-sm font-medium mb-4 text-center"
        >
          Password reset code sent to your email.
        </div>

        <!-- Send Button -->
        <button
          @click="submit"
          :disabled="!isEmailValid || isLoading"
          class="custom-button w-full flex items-center justify-center"
        >
          <span v-if="!isLoading">Send Reset Code</span>
          <span v-else class="auth-loader"></span>
        </button>

        <!-- Back to Login -->
        <div class="mt-4 text-sm text-center">
          Remembered your password?
          <router-link to="/login" class="register-text"
            >Back to Login</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { forgotPasswordApi } from "../service/auth";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      error: "",
      success: false,
      isLoading: false,
    };
  },
  computed: {
    isEmailValid() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.email);
    },
  },
  methods: {
    async submit() {
      this.error = "";
      this.success = false;

      if (!this.email) {
        this.error = "Email is required.";
        return;
      }

      if (!this.isEmailValid) {
        this.error = "Please enter a valid email address.";
        return;
      }

      try {
        this.isLoading = true;
        await forgotPasswordApi(this.email);
        this.success = true;
        this.$router.push({
          path: "/confirm-forgot-password",
          query: { email: this.email },
        });
      } catch (err) {
        this.error = err.message || "Something went wrong.";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
